import React from "react";
import SaasProductSelection from "./SaasProductSelection";
import style from "./SaasProductOption.module.css";

export default function SaasProductOption({
  option,
  activeSelectionIds,
  handleOptionSelectionClick,
  handleQtyChange,
  handleTargetPriceChange,
  getLinkedSelections,
  availableOptions,
}) {
  const doSomeSelectionsHavePrices = option.selections.some(
    selection => selection.product.price !== null
  );
  const isVisible = option.display === "1" && doSomeSelectionsHavePrices;

  function hasSaas(option) {
    return option.selections.some(sel => sel.is_saas === true);
  }

  return isVisible ? (
    <div>
      <table className={style.table}>
        <thead className={style.thead}>
          <tr>
          <th className={[style.th, style.selector].join(" ")}>{`${option.title}${option.required === "1" ? " (Required)" : ""}`}</th>
          <th></th>
          <td className={[style.td, style.qty].join(" ")}>QTY</td>
          <td className={[style.td, style.msp].join(" ")}>Minumum Sell Price</td>
          <td className={[style.td, style.tp].join(" ")}>{ hasSaas(option) && "Target Price" }</td>
          <td className={[style.td, style.term].join(" ")}>{ hasSaas(option) && "Term" }</td>
          <td className={[style.td, style.ft].join(" ")}>Finance Type</td>
          <td className={[style.td, style.total].join(" ")}>Total</td>
          </tr>
        </thead>
        <tbody>
          {option.selections.map(selection => (
            <SaasProductSelection
              key={selection.selection_id}
              selection={selection}
              handleSelectionClick={(selection, action) =>
                handleOptionSelectionClick(option, selection, action)
              }
              handleQtyChange={(selectionId, qty) =>
                handleQtyChange({
                  optionId: option.option_id,
                  selectionId,
                  qty,
                  allOptions: availableOptions
                })
              }
              handleTargetPriceChange={(selectionId, targetPrice) => 
                handleTargetPriceChange({
                  optionId: option.option_id,
                  selectionId,
                  targetPrice,
                  allOptions: availableOptions
                })
              }
              isActive={activeSelectionIds.includes(selection.selection_id)}
              type={option.type}
              linkedParts={getLinkedSelections(selection)}
            />
          ))}
        </tbody>
      </table>
    </div>
  ) : null;
}
